export default __webpack_public_path__ + "static/media/FECHAS_12.7225175c.png";